import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ToastItem, ToastService } from '@core/services/toast.service';

import { IconComponent, IconName } from '../icon/icon.component';

const ICON_BY_TYPE: Record<ToastItem['type'], IconName> = {
  success: 'check-circle',
  error: 'alert-circle',
  warning: 'alert-circle',
  info: 'info'
};

/**
 * Anchored inside `AppLayoutComponent`, renders the ToastService signal stack
 * with the `toast-in` keyframe. Auto-dismiss is owned by the service.
 */
@Component({
  selector: 'app-toast-host',
  standalone: true,
  imports: [IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './toast-host.component.html',
  styleUrl: './toast-host.component.scss'
})
export class ToastHostComponent {
  protected readonly toasts = inject(ToastService);

  protected iconFor(type: ToastItem['type']): IconName {
    return ICON_BY_TYPE[type];
  }

  dismiss(id: number): void {
    this.toasts.dismiss(id);
  }

  protected runAction(id: number): void {
    this.toasts.runAction(id);
  }
}
